import { MetricCard, MetricGrid } from "@nymbl/nos2-rules";
import { availableHours } from "@/lib/month/metrics";
import { formatHours } from "@/lib/time/rules";
import type { MonthSummary } from "@/schemas/month";

const hoursText = (hours: number | null) => (hours === null ? "—" : formatHours(hours));

/**
 * True capacity (capacity - PTO), Total guidance, Hours logged (productive). Facts, so they show
 * at 0 (DECISIONS 2026-11-02: the one exception to no tile that reads 0).
 */
export function GuidanceCards({ row }: { row: MonthSummary | null }) {
  return (
    <MetricGrid>
      <MetricCard
        label="True capacity"
        value={hoursText(row ? availableHours(row) : null)}
        detail="hrs"
      />
      <MetricCard label="Total guidance" value={hoursText(row ? row.planned : null)} detail="hrs" />
      <MetricCard
        label="Hours logged"
        value={hoursText(row ? row.productive : null)}
        detail="hrs"
      />
    </MetricGrid>
  );
}
